import { FC } from "react";
import Button from "../../../components/atoms/Button";
import Loader from "../../../components/atoms/Loader";
import { FSHTTPError } from "../../../errors";
import { WithRouterProps, withRouter } from "../../../helpers/RouterHelper";
import { useFlashMessage } from "../../../hooks/useFlashMessage";
import { SectionOperatorInvitationInterface } from "../../../interfaces/SectionOperatorInvitationInterface";
import { HTTP_ERROR_MESSAGE } from "../../../reducers/index";
import {
  useAcceptInvitation,
  useDenyInvitation,
} from "../useInvitationMutations";
import styles from "./styles.scss";

interface Props extends WithRouterProps {
  isLoading: boolean;
  invitation: SectionOperatorInvitationInterface | null;
}

const InvitationAccept: FC<Props> = (props) => {
  const { isLoading, invitation, navigate } = props;
  const { showErrorMessage } = useFlashMessage();

  // 招待承認・拒否のためのミューテーション
  const acceptMutation = useAcceptInvitation();
  const denyMutation = useDenyInvitation();

  // ローディング状態の計算
  const isSubmitting = acceptMutation.isPending || denyMutation.isPending;

  const handleAcceptInvite = () => {
    if (!invitation) {
      return;
    }
    acceptMutation.mutate(
      { invitationId: invitation.id },
      {
        onSuccess: () => {
          navigate(`/sections/${invitation.sectionId}`);
        },
        onError: (error) => {
          if (
            error instanceof FSHTTPError ||
            error.message === HTTP_ERROR_MESSAGE // リクエストしたが、APIのレスポンスステータスが401,403,404,422,503の場合以外、messageがHTTP_ERROR_MESSAGEになる
          ) {
            showErrorMessage("招待を承認できませんでした");
          } else {
            showErrorMessage(HTTP_ERROR_MESSAGE);
          }
          navigate("/sections");
        },
      },
    );
  };

  const handleDenyInvite = () => {
    if (!invitation) {
      return;
    }
    denyMutation.mutate(
      { invitationId: invitation.id },
      {
        onSuccess: () => {
          navigate("/sections");
        },
        onError: () => {
          showErrorMessage(HTTP_ERROR_MESSAGE);
          navigate("/sections");
        },
      },
    );
  };

  if (isLoading) {
    return <Loader loading />;
  }

  if (!invitation) {
    return null;
  }

  return (
    <div className={styles.root}>
      <div className={styles.heading}>
        <p>{invitation.fullName}から</p>
        <p>招待されています</p>
      </div>
      <div className={styles.body}>
        <p>{invitation.fullName}に所属する場合は、</p>
        <p>招待の承認をするとスタッフメンバーに登録されます。</p>
      </div>
      <div className={styles.accept}>
        <Button
          disabled={isLoading || isSubmitting}
          onClick={handleAcceptInvite}
        >
          {" "}
          招待を承認{" "}
        </Button>
      </div>
      <div>
        {invitation.role === "admin" ? null : (
          <button
            disabled={isLoading || isSubmitting}
            className={styles.deny}
            onClick={handleDenyInvite}
          >
            {" "}
            承認しない
          </button>
        )}
      </div>
    </div>
  );
};

export default withRouter<Props>(InvitationAccept);
